
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/selling/owners",
      function () {
        return require("private-next-pages/selling/owners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/selling/owners"])
      });
    }
  